(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var activeLinkId = null;
    var pendingTimeout = null;

    function getLinkedSections() {
      return Array.from(document.querySelectorAll('.about-content[data-about-linker]'));
    }

    function applyTileColors(target, linkId) {
      if (!target) return;
      var tile = Array.from(document.querySelectorAll('.about-tiles__tile[data-tile-link]'))
        .find(function (t) { return t.dataset.tileLink === linkId; });
      if (!tile) return;
      var bg = tile.style.backgroundColor;
      var color = tile.style.color;
      // Sync the bg of every linked panel + the body so when one panel fades
      // out (and another fades in), there's never a moment where the body's
      // default color shows through. All bgs animate to the same target color
      // via the CSS transition on .about-content--linked.
      if (bg) {
        getLinkedSections().forEach(function (sec) {
          sec.style.backgroundColor = bg;
          var innerEl = sec.querySelector('[data-about-content-inner]');
          if (innerEl) innerEl.style.backgroundColor = bg;
        });
        document.body.style.backgroundColor = bg;
      }
      if (color) {
        var inner = target.querySelector('[data-about-content-inner]');
        if (inner) inner.style.setProperty('--about-content-text', color);
      }
    }

    function activate(targetId, instant) {
      var all = getLinkedSections();
      if (all.length === 0) return;
      var target = all.find(function (s) { return s.dataset.aboutLinker === targetId; }) || all[0];

      var prevActive = null;
      all.forEach(function (s) {
        if (s.classList.contains('about-content--active')) prevActive = s;
      });

      if (prevActive === target && !instant) return;

      if (pendingTimeout !== null) {
        window.clearTimeout(pendingTimeout);
        pendingTimeout = null;
      }

      activeLinkId = target.dataset.aboutLinker;
      applyTileColors(target, activeLinkId);

      // Initial render — show the target instantly with no animation.
      if (instant) {
        all.forEach(function (s) {
          if (s === target) {
            s.removeAttribute('hidden');
            s.classList.add('about-content--active');
          } else {
            s.classList.remove('about-content--active');
            s.setAttribute('hidden', '');
          }
        });
        return;
      }

      // Reopen from closed state — no panel is active, so fade the target in
      // with a paint between removeAttribute('hidden') and the --active class
      // so the CSS opacity transition runs (otherwise the panel would just
      // pop in without an animation).
      if (!prevActive) {
        target.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            target.classList.add('about-content--active');
          });
        });
        return;
      }

      // Sequential cross-fade: fade old out fully, then fade new in. Keeps only
      // one panel in document flow at a time so heights never double, and the
      // page bg (synced above) covers the brief window when neither panel is
      // visible.
      prevActive.classList.remove('about-content--active');
      pendingTimeout = window.setTimeout(function () {
        pendingTimeout = null;
        prevActive.setAttribute('hidden', '');
        target.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            target.classList.add('about-content--active');
          });
        });
      }, 600);
    }

    // Close any open panel. Fades the current panel out, then drops it from
    // layout via `hidden` once the transition has finished. Body bg is left
    // as-is so the page doesn't flash a different colour while the panel
    // collapses.
    function deactivate() {
      var all = getLinkedSections();
      var current = null;
      all.forEach(function (s) {
        if (s.classList.contains('about-content--active')) current = s;
      });
      if (!current) return;

      if (pendingTimeout !== null) {
        window.clearTimeout(pendingTimeout);
        pendingTimeout = null;
      }

      activeLinkId = null;
      current.classList.remove('about-content--active');

      pendingTimeout = window.setTimeout(function () {
        pendingTimeout = null;
        current.setAttribute('hidden', '');
      }, 600);
    }

    function init() {
      var all = getLinkedSections();
      if (all.length === 0) return;
      var initialId = activeLinkId || all[0].dataset.aboutLinker;
      activate(initialId, true);

      var tiles = document.querySelectorAll('.about-tiles__tile[data-tile-link]');
      tiles.forEach(function (tile) {
        if (tile.__aboutTileLinkBound) return;
        tile.__aboutTileLinkBound = true;
        tile.addEventListener('click', function (e) {
          var linkId = tile.dataset.tileLink;
          var match = getLinkedSections().some(function (s) { return s.dataset.aboutLinker === linkId; });
          if (match) {
            e.preventDefault();
            activate(linkId, false);
          }
        });
      });

      var closeButtons = document.querySelectorAll('.about-content[data-about-linker] [data-about-close]');
      closeButtons.forEach(function (btn) {
        if (btn.__aboutCloseBound) return;
        btn.__aboutCloseBound = true;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          deactivate();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var SECTION_ID = 'cart-drawer';
    // Which step is showing: 'cart' or 'upsell'. Module-scoped so it survives
    // the drawer's innerHTML rerender (the IIFE runs once per page load).
    var currentStep = 'cart';

    function getDrawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function getSteps() {
      var d = getDrawer();
      return d ? d.querySelector('[data-cart-steps]') : null;
    }

    // Apply currentStep to the track. `instant` skips the slide animation —
    // used after a rerender (the track was just recreated) so it appears in
    // place instead of sliding across.
    function applyStep(instant) {
      var steps = getSteps();
      if (!steps) { currentStep = 'cart'; return; }
      // If the upsell step is gone (e.g. nothing left to add), fall back.
      if (currentStep === 'upsell' && !steps.querySelector('[data-step="upsell"]')) {
        currentStep = 'cart';
      }
      if (instant) {
        steps.style.transition = 'none';
        steps.setAttribute('data-step', currentStep);
        void steps.offsetWidth; // commit the no-transition state before re-enabling
        requestAnimationFrame(function() { steps.style.transition = ''; });
      } else {
        steps.setAttribute('data-step', currentStep);
      }
    }

    function goToStep(step) { currentStep = step; applyStep(false); }

    function open() {
      var d = getDrawer(); if (!d) return;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
    }
    function close() {
      var d = getDrawer(); if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    function syncHeaderCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = String(count);
      });
    }

    // ── Shipping zone (Dubai / Other Emirates) ──────────────────────────────
    // The cart can't know the shopper's emirate before checkout, so BOTH zones'
    // progress is rendered server-side and we just show the panel matching the
    // saved choice. The toggle needs no server round-trip (both panels are
    // already in the DOM). Re-applied after every rerender via bindDrawerEvents.
    var SHIP_ZONE_KEY = 'mira:ship-zone';
    var SHIP_ZONES = ['dubai', 'other'];

    function getSavedZone() {
      try {
        var z = localStorage.getItem(SHIP_ZONE_KEY);
        if (SHIP_ZONES.indexOf(z) !== -1) return z;
      } catch (e) {}
      return 'dubai';
    }

    function applyShipZone() {
      var d = getDrawer(); if (!d) return;
      var zone = getSavedZone();
      // summary_block is rendered in both step footers, so this touches every
      // panel/toggle in the drawer and keeps them in sync.
      d.querySelectorAll('[data-zone-panel]').forEach(function(p) {
        p.classList.toggle('hidden', p.getAttribute('data-zone-panel') !== zone);
      });
      d.querySelectorAll('[data-zone-select]').forEach(function(b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-zone-select') === zone ? 'true' : 'false');
      });
    }

    function rerender() {
      return fetch('/?section_id=' + SECTION_ID, { headers: { 'Accept': 'text/html' }})
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          var current = getDrawer();
          if (!fresh || !current) return;
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          bindDrawerEvents();
          // Re-apply the step instantly — the fresh track defaults to the cart
          // step, so without this an add made from the upsell step would snap
          // the shopper back to the bag.
          applyStep(true);
          if (wasOpen) {
            current.classList.add('is-open');
            current.setAttribute('aria-hidden', 'false');
          }
          var freshCount = fresh.querySelector('[data-cart-count]');
          if (freshCount) syncHeaderCount(freshCount.textContent.trim());
        });
    }

    function changeLine(lineEl, qty) {
      if (!lineEl) return Promise.resolve();
      var key = lineEl.getAttribute('data-line-key');
      lineEl.setAttribute('data-loading', '');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function() { return rerender(); })
      .catch(function() { lineEl.removeAttribute('data-loading'); });
    }

    function bindDrawerEvents() {
      var d = getDrawer(); if (!d) return;

      d.querySelectorAll('[data-cart-close]').forEach(function(btn) {
        btn.addEventListener('click', function(e) { e.preventDefault(); close(); });
      });

      d.querySelectorAll('[data-cart-line]').forEach(function(line) {
        var qtyEl = line.querySelector('[data-line-quantity]');
        var dec = line.querySelector('[data-quantity-decrement]');
        var inc = line.querySelector('[data-quantity-increment]');
        var rem = line.querySelector('[data-cart-remove]');

        if (dec) dec.addEventListener('click', function() {
          var current = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
          changeLine(line, Math.max(0, current - 1));
        });
        if (inc) inc.addEventListener('click', function() {
          var current = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
          changeLine(line, current + 1);
        });
        if (rem) rem.addEventListener('click', function() {
          changeLine(line, 0);
        });
      });

      // Restore the saved delivery zone on the freshly-bound markup (runs on
      // initial load, after every rerender, and on shopify:section:load).
      applyShipZone();
    }

    // Global toggle + step navigation. Delegated so the buttons keep working
    // after the drawer rerenders (they're recreated each time).
    document.addEventListener('click', function(e) {
      if (!e.target.closest) return;

      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); currentStep = 'cart'; applyStep(true); open(); return; }

      // Delivery-zone toggle: persist the choice and swap the visible panel.
      // Both panels are already server-rendered, so this needs no fetch.
      var zoneBtn = e.target.closest('[data-zone-select]');
      if (zoneBtn) {
        e.preventDefault();
        var zone = zoneBtn.getAttribute('data-zone-select');
        if (SHIP_ZONES.indexOf(zone) !== -1) {
          try { localStorage.setItem(SHIP_ZONE_KEY, zone); } catch (e2) {}
          applyShipZone();
        }
        return;
      }

      // Checkout on the cart step (only present when there's an upsell to show)
      // → slide to the most-loved step instead of leaving the page.
      var nextBtn = e.target.closest('[data-cart-next]');
      if (nextBtn) { e.preventDefault(); goToStep('upsell'); return; }

      // Back arrow / "Back to bag" on the upsell step → slide back.
      var backBtn = e.target.closest('[data-cart-back]');
      if (backBtn) { e.preventDefault(); goToStep('cart'); return; }
    });

    // ============================================================
    // QUICK ADD — global click handlers for the + button, the variant
    // pills inside the popover, and the ADD TO BAG confirm. Markup is
    // in snippets/quick-add-button.liquid; rendered onto cards in
    // sections/collection-category.liquid, the related products carousel
    // in sections/product.liquid, and the cart-drawer upsell step.
    //
    // Single-variant products: + button has data-quick-add-variant
    // baked in → direct add, no popover.
    // Multi-variant products: + button toggles the popover; pills
    // update the selected-variant attr on the confirm button; confirm
    // submits to /cart/add.js and dispatches cart:updated, which the
    // listener below picks up to rerender + open the drawer.
    // ============================================================
    function closeAllQuickAddPopovers(except) {
      document.querySelectorAll('[data-quick-add-popover]').forEach(function(p) {
        if (p === except) return;
        if (!p.classList.contains('is-open') && p.hasAttribute('hidden')) return;
        p.classList.remove('is-open');
        // Match the popover's transition duration so the fade/slide-out
        // can run before the element is hidden from the layout tree.
        var hideTimer = setTimeout(function() {
          if (!p.classList.contains('is-open')) p.setAttribute('hidden', '');
        }, 320);
        p.dataset.hideTimer = hideTimer;
        var pid = p.getAttribute('data-quick-add-popover');
        var btn = document.querySelector('[data-quick-add="' + pid + '"]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function performQuickAdd(variantId, btnEls) {
      if (!variantId) return Promise.resolve();
      Object.keys(btnEls).forEach(function(k) {
        if (btnEls[k]) btnEls[k].dataset.state = 'loading';
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function() {
          Object.keys(btnEls).forEach(function(k) {
            if (btnEls[k]) btnEls[k].dataset.state = 'success';
          });
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            Object.keys(btnEls).forEach(function(k) {
              if (btnEls[k]) btnEls[k].dataset.state = '';
            });
            closeAllQuickAddPopovers();
          }, 1200);
        })
        .catch(function() {
          Object.keys(btnEls).forEach(function(k) {
            if (btnEls[k]) btnEls[k].dataset.state = '';
          });
        });
    }

    document.addEventListener('click', function(e) {
      // 1. + button click
      var trigger = e.target.closest && e.target.closest('[data-quick-add]');
      if (trigger && !trigger.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var directVariant = trigger.getAttribute('data-quick-add-variant');
        if (directVariant) {
          // Single-variant product — add straight to cart.
          performQuickAdd(directVariant, { trigger: trigger });
          return;
        }
        // Multi-variant — toggle popover.
        var productId = trigger.getAttribute('data-quick-add');
        var popover = document.querySelector('[data-quick-add-popover="' + productId + '"]');
        if (!popover) return;
        var isOpen = popover.classList.contains('is-open');
        closeAllQuickAddPopovers(isOpen ? null : popover);
        if (isOpen) {
          popover.classList.remove('is-open');
          setTimeout(function() {
            if (!popover.classList.contains('is-open')) popover.setAttribute('hidden', '');
          }, 320);
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          // Cancel any pending hide-timer from a previous close.
          if (popover.dataset.hideTimer) {
            clearTimeout(parseInt(popover.dataset.hideTimer, 10));
            delete popover.dataset.hideTimer;
          }
          popover.removeAttribute('hidden');
          // Two rAFs guarantee the initial transform/opacity paints
          // before .is-open animates them — without this the popover
          // pops in instead of sliding (same gotcha as the cart drawer
          // open after rerender, see the cart:updated handler below).
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              popover.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
            });
          });
        }
        return;
      }

      // 2. Variant pill click inside an open popover
      var pill = e.target.closest && e.target.closest('[data-quick-add-variant-pill]');
      if (pill && !pill.disabled) {
        e.preventDefault();
        e.stopPropagation();
        var pop = pill.closest('[data-quick-add-popover]');
        if (!pop) return;
        pop.querySelectorAll('[data-quick-add-variant-pill]').forEach(function(p) {
          p.setAttribute('aria-checked', p === pill ? 'true' : 'false');
        });
        var confirm = pop.querySelector('[data-quick-add-confirm]');
        var price = pill.getAttribute('data-variant-price');
        var priceEl = pop.querySelector('[data-quick-add-confirm-price]');
        if (confirm) confirm.setAttribute('data-selected-variant', pill.getAttribute('data-quick-add-variant-pill'));
        if (priceEl && price) priceEl.innerHTML = price;

        // Swap the card's main image to the variant image (if the variant
        // has its own — variants without one inherit the product featured
        // image, in which case we leave the card unchanged). The popover's
        // parent IS the image container, so its first .quick-add-card-image
        // is the main product image (the secondary hover image, if present,
        // doesn't carry that class).
        var variantImage = pill.getAttribute('data-variant-image');
        if (variantImage) {
          var imgRoot = pop.parentElement;
          var cardImg = imgRoot && imgRoot.querySelector('.quick-add-card-image');
          if (cardImg) {
            // Clear srcset so the browser uses the new src directly, otherwise
            // a stale responsive variant of the previous image keeps painting.
            cardImg.removeAttribute('srcset');
            cardImg.setAttribute('src', variantImage);
          }
          // Once a variant has been committed, the secondary hover-image
          // (.product-card__hover-image / .collection-grid__hover-image)
          // would fade in on :hover and cover the swapped variant image.
          // Hide it so the customer keeps seeing the variant they picked.
          // Inline display:none beats the existing :hover opacity rule
          // without needing !important or per-section CSS.
          if (imgRoot) {
            imgRoot.querySelectorAll('[class*="hover-image"]').forEach(function(hov) {
              hov.style.display = 'none';
            });
          }
        }
        return;
      }

      // 3. ADD TO BAG confirm click
      var confirmBtn = e.target.closest && e.target.closest('[data-quick-add-confirm]');
      if (confirmBtn) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = confirmBtn.getAttribute('data-selected-variant');
        var pop2 = confirmBtn.closest('[data-quick-add-popover]');
        var triggerForPop = pop2 ? document.querySelector('[data-quick-add="' + pop2.getAttribute('data-quick-add-popover') + '"]') : null;
        performQuickAdd(variantId, { trigger: triggerForPop, confirm: confirmBtn });
        return;
      }

      // 4. Outside-click closes any open popover
      if (!e.target.closest || !e.target.closest('[data-quick-add-popover]')) {
        closeAllQuickAddPopovers();
      }
    });

    // Esc: on the upsell step, go back to the bag first; otherwise close.
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var d = getDrawer();
      if (d && d.classList.contains('is-open')) {
        if (currentStep === 'upsell') { goToStep('cart'); }
        else { close(); }
      }
      closeAllQuickAddPopovers();
    });

    // Other code can dispatch this event to refresh the drawer (e.g. ajax add-to-cart)
    document.addEventListener('cart:updated', function() {
      rerender().then(function() {
        // rerender replaced the panel's innerHTML, so the <aside class="cart-drawer__panel">
        // was just destroyed and recreated with `translate-x-full` baked in. If we add
        // .is-open in the same microtask, the new panel's initial offscreen state never
        // paints — the browser collapses insert + class change into one frame and the
        // transform transition is skipped, so the drawer pops in instead of sliding.
        // Two rAFs guarantee the browser commits the initial state to a paint before
        // the .is-open rule overrides the transform and the slide can run.
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { open(); });
        });
      });
    });

    bindDrawerEvents();

    // If we just redirected away from /cart (sections/cart.liquid), open the
    // drawer immediately on the landing page so the user lands in the cart UI.
    try {
      if (sessionStorage.getItem('mira:open-cart-drawer') === '1') {
        sessionStorage.removeItem('mira:open-cart-drawer');
        currentStep = 'cart';
        applyStep(true);
        open();
      }
    } catch (e) {}

    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector && event.target.querySelector('[data-cart-drawer]')) {
        bindDrawerEvents();
        applyStep(true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initAutoScroll(root) {
      if (!root) return;

      // Skip in the theme editor preview — auto-scrolling while a merchant is
      // editing the banner would yank them off the section they're tweaking.
      if (window.Shopify && window.Shopify.designMode) return;

      // Respect reduced-motion preference — never auto-scroll.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Don't fire twice for the same node (shopify:section:load could re-run init).
      if (root.dataset.autoScrollFired === '1') return;

      var delay = parseInt(root.getAttribute('data-auto-scroll-delay'), 10);
      if (!delay || delay <= 0) return;

      var duration = parseInt(root.getAttribute('data-auto-scroll-duration'), 10);
      if (!duration || duration <= 0) duration = 1200;

      var aborted = false;
      function abort() {
        if (aborted) return;
        aborted = true;
        window.removeEventListener('wheel', abort);
        window.removeEventListener('touchstart', abort);
        window.removeEventListener('keydown', onKey);
      }
      function onKey(e) {
        // Any explicit scroll-by-keyboard input cancels the pending auto-scroll.
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' ||
            e.key === 'PageDown' || e.key === 'PageUp' ||
            e.key === ' ' || e.key === 'Home' || e.key === 'End') {
          abort();
        }
      }
      window.addEventListener('wheel', abort, { passive: true });
      window.addEventListener('touchstart', abort, { passive: true });
      window.addEventListener('keydown', onKey);

      // Cubic ease-in-out: slow start, fast middle, slow settle. Feels right
      // for a passive scroll where the visitor is being carried along — a pure
      // ease-out (matching the rest of the site's reveal motion) reaches the
      // destination too abruptly when the distance is a full viewport.
      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function performScroll() {
        if (aborted) return;
        root.dataset.autoScrollFired = '1';
        var rect = root.getBoundingClientRect();
        var startY = window.scrollY;
        var targetY = startY + rect.bottom;
        var distance = targetY - startY;
        if (Math.abs(distance) < 1) return;

        var startTime = null;
        function step(now) {
          if (aborted) return;
          if (startTime === null) startTime = now;
          var t = Math.min((now - startTime) / duration, 1);
          window.scrollTo(0, startY + distance * easeInOutCubic(t));
          if (t < 1) {
            requestAnimationFrame(step);
          } else {
            // Animation finished cleanly — drop the abort listeners so they
            // don't sit attached for the rest of the session.
            window.removeEventListener('wheel', abort);
            window.removeEventListener('touchstart', abort);
            window.removeEventListener('keydown', onKey);
          }
        }
        requestAnimationFrame(step);
      }

      function start() {
        // Wait for the page-intro loader to finish — sections/page-intro.liquid
        // removes `page-intro-locked` from <body> when the loader is fully
        // hidden. Counting the configured delay from THAT point makes the
        // visible "stay on banner" pause match what the merchant configures
        // regardless of network speed or loader_min_ms.
        if (document.body.classList.contains('page-intro-locked')) {
          var obs = new MutationObserver(function() {
            if (!document.body.classList.contains('page-intro-locked')) {
              obs.disconnect();
              setTimeout(performScroll, delay);
            }
          });
          obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        } else {
          setTimeout(performScroll, delay);
        }
      }

      if (document.readyState === 'complete') {
        start();
      } else {
        window.addEventListener('load', start, { once: true });
      }
    }

    function initPillSync(root) {
      if (!root) return;
      if (root.dataset.pillSyncFired === '1') return;
      root.dataset.pillSyncFired = '1';

      var img = root.querySelector('img');
      var heroEl = root.querySelector('.category-banner__heading');
      var productsList = root.querySelector('.category-banner__products');

      // Snapshot the original markup so we can restore it when no pill is active.
      var orig = {
        src: img ? img.getAttribute('src') : null,
        srcset: img ? img.getAttribute('srcset') : null,
        sizes: img ? img.getAttribute('sizes') : null,
        alt: img ? img.getAttribute('alt') : null,
        hero: heroEl ? heroEl.innerHTML : null,
        products: productsList ? productsList.innerHTML : null
      };

      function setAttrOrRemove(el, name, value) {
        if (value === null || value === undefined) el.removeAttribute(name);
        else el.setAttribute(name, value);
      }

      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function restoreOriginals() {
        if (img) {
          setAttrOrRemove(img, 'src', orig.src);
          setAttrOrRemove(img, 'srcset', orig.srcset);
          setAttrOrRemove(img, 'sizes', orig.sizes);
          setAttrOrRemove(img, 'alt', orig.alt);
        }
        if (heroEl && orig.hero !== null) heroEl.innerHTML = orig.hero;
        if (productsList && orig.products !== null) productsList.innerHTML = orig.products;
      }

      function applyFromButton(btn) {
        // Reset to originals first, then layer in any non-empty pill data.
        restoreOriginals();
        if (!btn) return;

        var newSrc = btn.getAttribute('data-banner-src');
        if (img && newSrc) {
          var newSrcset = btn.getAttribute('data-banner-srcset');
          var newAlt = btn.getAttribute('data-banner-alt');
          img.setAttribute('src', newSrc);
          if (newSrcset) img.setAttribute('srcset', newSrcset); else img.removeAttribute('srcset');
          if (newAlt) img.setAttribute('alt', newAlt);
        }

        var newHero = btn.getAttribute('data-banner-hero');
        if (heroEl && newHero) heroEl.innerHTML = newHero;

        var newProductsJson = btn.getAttribute('data-banner-products');
        if (productsList && newProductsJson) {
          try {
            var titles = JSON.parse(newProductsJson);
            if (Array.isArray(titles) && titles.length > 0) {
              var html = '';
              for (var i = 0; i < titles.length; i++) {
                html += '<li>' + escapeHtml(titles[i]) + '</li>';
              }
              productsList.innerHTML = html;
            }
          } catch (e) {}
        }
      }

      document.addEventListener('mira:pill-changed', function (e) {
        applyFromButton(e.detail && e.detail.activeButton);
      });
    }

    document.querySelectorAll('[id^="category-banner-"]').forEach(function (root) {
      initAutoScroll(root);
      initPillSync(root);
    });

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector && event.target.querySelector('[id^="category-banner-"]');
      if (root) {
        initAutoScroll(root);
        initPillSync(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (!root) return;
      var items = root.querySelectorAll('[data-category-target]');
      var panels = root.querySelectorAll('[data-category-content]');
      var shopSelected = root.querySelector('[data-shop-selected]');

      function setActive(item) {
        if (!item) return;
        var targetId = item.dataset.categoryTarget;
        var bgColor = item.dataset.bgColor;
        var headerTextColor = item.dataset.headerTextColor;
        var collectionUrl = item.dataset.collectionUrl;

        items.forEach(function(i) { i.classList.toggle('is-active', i === item); });
        panels.forEach(function(p) {
          var isActive = p.dataset.categoryContent === targetId;
          p.classList.toggle('is-active', isActive);
          p.classList.toggle('opacity-0', !isActive);
          p.classList.toggle('pointer-events-none', !isActive);
        });

        root.style.backgroundColor = bgColor;

        // Override the standard header's BACKGROUND to match this category, but
        // leave the header's text/border colours alone — the nav links should
        // stay a single fixed colour across hovers, not flicker per category.
        document.documentElement.style.setProperty('--header-bg-override', bgColor);

        // Text override is scoped to THIS section only so the category-list
        // labels (and the mobile "Shop Selected" link) still pick up the
        // per-category colour. The site header lives outside this element, so
        // it continues to read the :root default and is unaffected.
        root.style.setProperty('--header-text-override', headerTextColor);

        if (shopSelected) shopSelected.href = collectionUrl;
      }

      var desktopMQ = window.matchMedia('(min-width: 1024px)');

      items.forEach(function(item) {
        item.addEventListener('mouseenter', function() { setActive(item); });
        item.addEventListener('focus', function() { setActive(item); });
        item.addEventListener('click', function() {
          var url = item.dataset.collectionUrl;
          if (desktopMQ.matches && url && url !== '#') {
            window.location.href = url;
            return;
          }
          setActive(item);
        });
      });

      // Apply initial active state from the first block
      if (items.length > 0) setActive(items[0]);
    }

    document.querySelectorAll('[data-category-page]').forEach(init);

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector('[data-category-page]') || event.target;
      if (root && root.matches && root.matches('[data-category-page]')) init(root);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      if (event.target.querySelector && event.target.querySelector('[data-category-page]')) {
        document.documentElement.style.removeProperty('--header-bg-override');
        document.documentElement.style.removeProperty('--header-text-override');
        document.documentElement.style.removeProperty('--header-border-override');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'mira-cat-view-cols';

    function init(root) {
      if (!root) return;
      var grid = root.querySelector('[data-product-grid]');
      var loadMore = root.querySelector('[data-load-more]');
      var counter = root.querySelector('[data-product-counter]');
      var viewToggle = root.querySelector('[data-view-toggle]');
      var filterToggle = root.querySelector('[data-filters-toggle]');
      var filterOverlay = root.querySelector('[data-filter-overlay]');
      var filterCloseEls = root.querySelectorAll('[data-filter-close]');
      var pillButtons = root.querySelectorAll('[data-pill-filter]');

      // Hoisted so the live-filter swap can reapply the user's column
      // choice onto a freshly-rendered grid. Reads `grid` from the
      // enclosing closure, which is updated after every swap.
      function applyView(cols) {
        if (!viewToggle || !grid) return;
        viewToggle.dataset.current = cols;
        grid.style.setProperty('--lg-cols', cols);
        // Mirror the column count onto the grid as a data attribute so
        // CSS rules (e.g. the 6-col stacked-currency price layout) can
        // hook off the active view.
        grid.dataset.cols = cols;
        // 6-column view halves the gap so cards stay wide enough to
        // fit the title + price row without the price overflowing.
        var baseGap = parseFloat(grid.dataset.baseGap) || 0;
        var gap = cols === '6' ? baseGap * 0.5 : baseGap;
        grid.style.setProperty('--lg-gap', gap + 'rem');
        var labels = viewToggle.querySelectorAll('[data-when-current]');
        Array.prototype.forEach.call(labels, function (el) {
          el.hidden = el.dataset.whenCurrent !== cols;
        });
      }

      // counterDefaultText backs the "X of Y products" readout. Filtering is
      // now fully server-side (pills toggle the native Category filter), so it
      // is refreshed only after a live-filter swap or a Load-more append and
      // always reflects the current server-filtered total.
      var counterDefaultText = counter ? counter.textContent.trim() : '';

      // ============================================================
      // PILL <-> CATEGORY FILTER bridge.
      //
      // The pill row and the Category group inside the filter overlay are two
      // views of the SAME native storefront filter (custom.category). Both are
      // rendered from `category_filter.values`, so they share labels, values
      // and selection state. The bridge only needs to:
      //
      //   - Pill click  -> toggle the matching Category checkbox (matched by
      //                    value) and let the existing live-filter pipeline
      //                    fetch the filtered result. No client-side hiding.
      //   - After swap  -> categoryToPill() re-reads the freshly-rendered
      //                    checkboxes, sets every pill's aria-pressed, and
      //                    fires `mira:pill-changed` so the banner tracks the
      //                    single active category (reverts on 0 or >1).
      //
      // Category filtering is multi-select (checkboxes), so more than one pill
      // can be pressed at once — consistent with the side panel.
      // ============================================================
      function getCategoryGroup() {
        return filterForm && filterForm.querySelector('[data-filter-label="category"]');
      }

      function getCategoryInputByValue(val) {
        var group = getCategoryGroup();
        if (!group || val == null || val === '') return null;
        var target = String(val).toLowerCase();
        var inputs = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');
        for (var i = 0; i < inputs.length; i++) {
          if ((inputs[i].value || '').toLowerCase() === target) return inputs[i];
        }
        return null;
      }

      // Mirror the Category group's checked state onto the pills (matched by
      // value), and announce the active category for the hero banner.
      function categoryToPill() {
        if (!pillButtons.length) return;
        var group = getCategoryGroup();
        var checkedVals = [];
        if (group) {
          Array.prototype.forEach.call(group.querySelectorAll('input:checked'), function (cb) {
            if (cb.value !== '') checkedVals.push(cb.value.toLowerCase());
          });
        }
        var activeBtn = null;
        Array.prototype.forEach.call(pillButtons, function (b) {
          var pv = (b.getAttribute('data-filter-value') || '').toLowerCase();
          var match = pv !== '' && checkedVals.indexOf(pv) !== -1;
          b.setAttribute('aria-pressed', match ? 'true' : 'false');
          if (match && checkedVals.length === 1) activeBtn = b;
        });
        document.dispatchEvent(new CustomEvent('mira:pill-changed', {
          detail: { activeButton: activeBtn }
        }));
      }

      Array.prototype.forEach.call(pillButtons, function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
          var cb = getCategoryInputByValue(btn.getAttribute('data-filter-value') || '');
          if (!cb) return;
          cb.checked = !cb.checked;
          // Optimistic feedback; categoryToPill() corrects from the server
          // response once the swap lands.
          btn.setAttribute('aria-pressed', cb.checked ? 'true' : 'false');
          // Drives the existing live-filter change handler on the form.
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // ============================================================
      // FILTER OVERLAY — open / close, body scroll lock, ESC to close
      // ============================================================
      function openOverlay() {
        if (!filterOverlay) return;
        filterOverlay.classList.add('is-open');
        filterOverlay.classList.remove('hidden');
        filterOverlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('filter-overlay-open');
      }
      function closeOverlay() {
        if (!filterOverlay) return;
        filterOverlay.classList.remove('is-open');
        filterOverlay.classList.add('hidden');
        filterOverlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('filter-overlay-open');
      }

      if (filterToggle && filterOverlay) {
        filterToggle.addEventListener('click', openOverlay);
      }
      Array.prototype.forEach.call(filterCloseEls, function (btn) {
        btn.addEventListener('click', closeOverlay);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && filterOverlay && filterOverlay.classList.contains('is-open')) {
          closeOverlay();
        }
      });

      // Live filtering: fetch + swap on change, no full reload.
      // Outer closures (grid, counter, loadMore, allPagesLoaded) are
      // refreshed after every swap so pill + load-more code keeps
      // working against the new DOM.
      var filterForm = filterOverlay && filterOverlay.querySelector('[data-filter-form]');
      var filterAbort = null;
      var filterTimer = null;

      function refreshFilterFormRefs() {
        var applyBtn = filterForm && filterForm.querySelector('button[type="submit"]');
        if (applyBtn) applyBtn.classList.add('hidden');
        initPriceRanges();
        // Sync pill row to whatever the filter form's Category section
        // currently has checked. Catches initial page load (URL filters
        // active from a refresh / share / Back-Forward navigation) and
        // every fetch swap, so pills + checkboxes always agree.
        categoryToPill();
      }

      function initPriceRanges() {
        if (!filterForm) return;
        filterForm.querySelectorAll('[data-price-range]').forEach(function (root) {
          if (root._priceInit) return;
          root._priceInit = true;
          var minInput = root.querySelector('[data-price-min]');
          var maxInput = root.querySelector('[data-price-max]');
          var minDisplay = root.querySelector('[data-price-min-display]');
          var maxDisplay = root.querySelector('[data-price-max-display]');
          var fill = root.querySelector('[data-price-fill]');
          var currency = root.getAttribute('data-currency') || '';
          var max = parseInt(root.getAttribute('data-range-max'), 10) || 1;
          if (!minInput || !maxInput) return;

          function paint() {
            var lo = parseInt(minInput.value, 10);
            var hi = parseInt(maxInput.value, 10);
            if (lo > hi) {
              // Keep handles from crossing — clamp the one being dragged.
              if (this === minInput) { minInput.value = hi; lo = hi; }
              else { maxInput.value = lo; hi = lo; }
            }
            if (minDisplay) minDisplay.textContent = currency + ' ' + lo + '.00';
            if (maxDisplay) maxDisplay.textContent = currency + ' ' + hi + '.00';
            if (fill) {
              fill.style.left = (lo / max * 100) + '%';
              fill.style.right = (100 - hi / max * 100) + '%';
            }
          }
          minInput.addEventListener('input', paint);
          maxInput.addEventListener('input', paint);
          paint();
        });
      }

      function buildFilterURL() {
        if (!filterForm) return null;
        var fd = new FormData(filterForm);
        var params = new URLSearchParams();
        fd.forEach(function (value, key) {
          // Drop empties so the address bar doesn't show &filter.v.price.gte=
          if (value !== '' && value != null) params.append(key, value);
        });
        var qs = params.toString();
        return filterForm.action + (qs ? '?' + qs : '');
      }

      function setFilterBusy(busy) {
        if (!filterForm) return;
        filterForm.setAttribute('aria-busy', busy ? 'true' : 'false');
        filterForm.style.opacity = busy ? '0.6' : '';
        filterForm.style.pointerEvents = busy ? 'none' : '';
      }

      function applyFiltersTo(url, opts) {
        if (!url || !filterForm) return;
        opts = opts || {};

        if (filterAbort) { try { filterAbort.abort(); } catch (_) {} }
        filterAbort = ('AbortController' in window) ? new AbortController() : null;
        setFilterBusy(true);

        fetch(url, {
          headers: { 'Accept': 'text/html' },
          signal: filterAbort ? filterAbort.signal : undefined
        })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            // -- Product grid -----------------------------------------
            var freshGrid = doc.querySelector('[data-product-grid]');
            if (grid && freshGrid) {
              grid.replaceWith(freshGrid);
              grid = freshGrid;
              // The fresh grid is server-rendered with the default
              // 4-column layout. Re-apply the user's current view-by
              // choice (4 ↔ 6) onto the new element so the swap doesn't
              // silently reset the column count.
              if (viewToggle) applyView(viewToggle.dataset.current || '4');
            }

            // -- Counter ---------------------------------------------
            var freshCounter = doc.querySelector('[data-product-counter]');
            if (freshCounter) {
              var liveCounter = root.querySelector('[data-product-counter]');
              if (liveCounter) {
                liveCounter.textContent = freshCounter.textContent.trim();
                counter = liveCounter;
                counterDefaultText = counter.textContent.trim();
              }
            }

            // -- Load-more anchor -------------------------------------
            var freshLoadMore = doc.querySelector('[data-load-more]');
            var liveLoadMore = root.querySelector('[data-load-more]');
            if (liveLoadMore && freshLoadMore) {
              liveLoadMore.href = freshLoadMore.getAttribute('href') || '';
              liveLoadMore.textContent = freshLoadMore.textContent.trim();
              loadMore = liveLoadMore;
            } else if (liveLoadMore && !freshLoadMore) {
              liveLoadMore.remove();
              loadMore = null;
            } else if (!liveLoadMore && freshLoadMore) {
              // Previous swap removed the load-more (e.g. filtered set
              // was a single page); the new wider result has more pages
              // again, so insert the fresh anchor before the counter
              // (its server-rendered position).
              var counterEl = root.querySelector('[data-product-counter]');
              if (counterEl && counterEl.parentNode) {
                counterEl.parentNode.insertBefore(freshLoadMore, counterEl);
                loadMore = freshLoadMore;
              }
            }
            allPagesLoaded = !loadMore || !loadMore.getAttribute('href');

            // -- Filter form (counts + active states + price values) --
            var freshForm = doc.querySelector('[data-filter-form]');
            if (freshForm && filterForm) {
              // Preserve open <details> + focused-input cursor across the swap.
              var openStates = [];
              filterForm.querySelectorAll('details.filter-group').forEach(function (d) {
                openStates.push(d.open);
              });
              var focusedName = null;
              var ae = document.activeElement;
              if (ae && filterForm.contains(ae) && ae.name) {
                focusedName = ae.name;
              }

              filterForm.innerHTML = freshForm.innerHTML;

              filterForm.querySelectorAll('details.filter-group').forEach(function (d, i) {
                if (typeof openStates[i] === 'boolean') d.open = openStates[i];
              });
              if (focusedName) {
                var refocus = filterForm.querySelector('[name="' + focusedName + '"]');
                if (refocus) {
                  refocus.focus({ preventScroll: true });
                  if (refocus.value != null) {
                    var v = refocus.value;
                    try { refocus.setSelectionRange(v.length, v.length); } catch (_) {}
                  }
                }
              }
              refreshFilterFormRefs();
            }

            // -- URL ---------------------------------------------------
            if (!opts.skipPushState) {
              history.pushState({ filtersApplied: true }, '', url);
            }
            setFilterBusy(false);
          })
          .catch(function (err) {
            if (err && (err.name === 'AbortError' || err === 'AbortError')) return;
            setFilterBusy(false);
          });
      }

      function debouncedApply(ms) {
        if (filterTimer) clearTimeout(filterTimer);
        filterTimer = setTimeout(function () {
          applyFiltersTo(buildFilterURL());
        }, ms || 0);
      }

      if (filterForm) {
        refreshFilterFormRefs();

        filterForm.addEventListener('change', function (e) {
          var t = e.target;
          if (t && (t.type === 'checkbox' || t.type === 'radio' || t.type === 'range')) {
            debouncedApply(0);
          }
        });
        // 500ms debounce so typing min + max doesn't fire two fetches.
        filterForm.addEventListener('input', function (e) {
          var t = e.target;
          if (t && t.type === 'number') {
            debouncedApply(500);
          }
        });
        filterForm.addEventListener('submit', function (e) {
          e.preventDefault();
          applyFiltersTo(buildFilterURL());
        });
        // CLEAR <a> — fetch the href instead of full navigation.
        filterForm.addEventListener('click', function (e) {
          var a = e.target.closest && e.target.closest('a[href]');
          if (a && filterForm.contains(a)) {
            e.preventDefault();
            applyFiltersTo(a.href);
          }
        });

        // Re-fetch on Back/Forward so the grid matches the address bar.
        window.addEventListener('popstate', function () {
          applyFiltersTo(window.location.href, { skipPushState: true });
        });
      }

      // ============================================================
      // LOAD MORE — fetch next page, append products, update counter.
      // Shared between manual Load More clicks and the pill-triggered
      // eager-load loop. A single in-flight promise serialises all
      // loads so the two paths can't race for the same `loadMore.href`.
      // ============================================================
      var allPagesLoaded = !loadMore || !loadMore.getAttribute('href');
      var pageLoadInFlight = null;

      function setLoadMoreBusy(busy) {
        if (!loadMore) return;
        if (busy) {
          loadMore.setAttribute('aria-busy', 'true');
          loadMore.style.opacity = '0.5';
          loadMore.style.pointerEvents = 'none';
        } else {
          loadMore.removeAttribute('aria-busy');
          loadMore.style.opacity = '';
          loadMore.style.pointerEvents = '';
        }
      }

      function fetchNextPage() {
        if (pageLoadInFlight) return pageLoadInFlight;
        if (!loadMore) return Promise.resolve(false);
        var nextUrl = loadMore.getAttribute('href');
        if (!nextUrl) return Promise.resolve(false);

        setLoadMoreBusy(true);

        pageLoadInFlight = fetch(nextUrl, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextSection = doc.querySelector('[data-collection-category]');
            if (!nextSection) return false;

            // Append new product items to existing grid.
            var newGrid = nextSection.querySelector('[data-product-grid]');
            if (newGrid && grid) {
              Array.prototype.forEach.call(newGrid.children, function (item) {
                grid.appendChild(item.cloneNode(true));
              });
            }

            // Update counter ("12 of 52" → "24 of 52"). Stash the new
            // text as the default so clearing pill filters restores the
            // freshly-loaded total instead of the page-load total.
            var newCounter = nextSection.querySelector('[data-product-counter]');
            if (newCounter && counter) {
              counterDefaultText = newCounter.textContent.trim();
              counter.textContent = counterDefaultText;
            }

            // Advance to next page or hide the button when exhausted.
            var newLoadMore = nextSection.querySelector('[data-load-more]');
            var hasMore = !!(newLoadMore && newLoadMore.getAttribute('href'));
            if (hasMore) {
              loadMore.setAttribute('href', newLoadMore.getAttribute('href'));
            } else {
              loadMore.removeAttribute('href');
              loadMore.style.display = 'none';
              allPagesLoaded = true;
            }
            return hasMore;
          })
          .catch(function () { return false; })
          .then(function (hasMore) {
            setLoadMoreBusy(false);
            pageLoadInFlight = null;
            return hasMore;
          });

        return pageLoadInFlight;
      }

      // Delegated on root so a load-more anchor that was removed and
      // re-inserted by a live-filter swap still triggers fetchNextPage
      // (the inserted node has no per-element listener). The next-page URL
      // carries the active filters, so appended products are already the
      // correct (server-filtered) set — no client-side re-filter needed.
      root.addEventListener('click', function (e) {
        var anchor = e.target.closest && e.target.closest('[data-load-more]');
        if (!anchor || !root.contains(anchor)) return;
        if (!anchor.getAttribute('href')) return;
        e.preventDefault();
        fetchNextPage();
      });

      // ============================================================
      // VIEW BY 4 ↔ 6 toggle (desktop only — mobile stays 1 col)
      // ============================================================
      if (viewToggle) {
        viewToggle.addEventListener('click', function () {
          var current = viewToggle.dataset.current || '4';
          var next = current === '4' ? '6' : '4';
          applyView(next);
          try {
            localStorage.setItem(STORAGE_KEY, next);
          } catch (e) {}
        });

        // Restore saved preference on load
        try {
          var saved = localStorage.getItem(STORAGE_KEY);
          if (saved === '6' || saved === '4') {
            applyView(saved);
          }
        } catch (e) {}
      }
    }

    document.querySelectorAll('[data-collection-category]').forEach(init);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-collection-category]') || event.target;
      if (root && root.matches && root.matches('[data-collection-category]')) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCollectionGrid(root) {
      if (!root) return;
      var track = root.querySelector('[data-collection-grid-track]');
      if (!track) return;
      var prev = root.querySelector('[data-collection-grid-prev]');
      var next = root.querySelector('[data-collection-grid-next]');
      var progress = root.querySelector('[data-collection-grid-progress]');

      function isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches;
      }

      function cardStep() {
        // Desktop snaps by `.set` (each set = 100% of track width).
        // Mobile snaps by `.card` (each card = 85vw). Sets exist in the DOM
        // at both breakpoints but render as `display: contents` on mobile,
        // so we measure the appropriate element per breakpoint.
        var query = isDesktop()
          ? '.collection-grid__set'
          : '.collection-grid__card';
        var first = track.querySelector(query);
        if (!first) return track.clientWidth;
        var rect = first.getBoundingClientRect();
        if (rect.width <= 0) return track.clientWidth;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return rect.width + gap;
      }

      function visibleCount() {
        var step = cardStep();
        return step > 0 ? Math.max(1, Math.round(track.clientWidth / step)) : 1;
      }

      function setsCount() {
        // On desktop the snap units are sets; on mobile they're cards.
        var total = isDesktop()
          ? track.children.length
          : track.querySelectorAll('.collection-grid__card').length;
        return Math.max(1, Math.ceil(total / visibleCount()));
      }

      function update() {
        if (!progress) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          progress.style.width = '100%';
          progress.style.left = '0%';
        } else {
          var widthPct = (track.clientWidth / track.scrollWidth) * 100;
          var travelPct = (100 - widthPct) * (track.scrollLeft / max);
          progress.style.width = widthPct + '%';
          progress.style.left = travelPct + '%';
        }
      }

      function scrollToSet(index) {
        var sets = setsCount();
        if (sets <= 1) return;
        var max = track.scrollWidth - track.clientWidth;
        var wrapped = ((index % sets) + sets) % sets;
        track.scrollTo({ left: (wrapped / (sets - 1)) * max, behavior: 'smooth' });
      }

      function currentSetIndex() {
        var sets = setsCount();
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        return sets > 1 ? Math.round(ratio * (sets - 1)) : 0;
      }

      if (prev) prev.addEventListener('click', function() { scrollToSet(currentSetIndex() - 1); });
      if (next) next.addEventListener('click', function() { scrollToSet(currentSetIndex() + 1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      track.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          var max = track.scrollWidth - track.clientWidth;
          if (max > 0) {
            e.preventDefault();
            track.scrollLeft += e.deltaX;
          }
        }
      }, { passive: false });

      update();
      requestAnimationFrame(update);
      window.addEventListener('load', update);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(update);
      }
    }

    document.querySelectorAll('[data-section-id][id^="collection-grid-"]').forEach(initCollectionGrid);

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector('[id^="collection-grid-"]') || event.target;
      initCollectionGrid(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifting"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    if (!scope || scope.dataset.giftingBound === '1') return;
    var triggers = scope.querySelectorAll('[data-gifting-trigger]');
    var images = scope.querySelectorAll('[data-gifting-image]');
    if (!triggers.length || !images.length) return;
    scope.dataset.giftingBound = '1';

    function show(id) {
      images.forEach(function (img) {
        img.style.opacity = img.getAttribute('data-gifting-image') === id ? '1' : '0';
      });
    }
    function hide() {
      images.forEach(function (img) { img.style.opacity = '0'; });
    }

    triggers.forEach(function (el) {
      var id = el.getAttribute('data-gifting-trigger');
      el.addEventListener('mouseenter', function () { show(id); });
      el.addEventListener('mouseleave', hide);
      el.addEventListener('focusin', function () { show(id); });
      el.addEventListener('focusout', hide);
    });
  }

  document.querySelectorAll('[data-gifting-section]').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (target.matches && target.matches('[data-gifting-section]')) {
      init(target);
    } else {
      var inner = target.querySelector && target.querySelector('[data-gifting-section]');
      if (inner) init(inner);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    var scope = target.matches && target.matches('[data-gifting-section]')
      ? target
      : (target.querySelector && target.querySelector('[data-gifting-section]'));
    if (scope) delete scope.dataset.giftingBound;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    function initHeader(root) {
      if (!root) return;
      var overlay = document.querySelector('[data-nav-overlay]');
      var openBtn = root.querySelector('[data-nav-open]');
      var closeBtn = overlay ? overlay.querySelector('[data-nav-close]') : null;

      if (!overlay || !openBtn) return;

      function open() {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('site-nav-open');
      }
      function close() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('site-nav-open');
      }

      openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') close();
      });

      // Inline search bar — toggled by the search icon in the navbar.
      // Default state is `!hidden` (Tailwind important) so it wins over
      // `lg:flex` until the toggle drops the important `hidden`. Results
      // render into the anchored dropdown beneath the input.
      var searchForm = root.querySelector('[data-header-search]');
      var searchInput = searchForm ? searchForm.querySelector('[data-header-search-input]') : null;
      var searchToggleBtns = document.querySelectorAll('[data-search-toggle]');
      var resultsHost = searchForm && searchForm.querySelector('[data-header-search-results]');
      var resultsLimit = parseInt(searchForm && searchForm.getAttribute('data-results-limit'), 10) || 6;
      var minChars = parseInt(searchForm && searchForm.getAttribute('data-min-chars'), 10) || 2;

      function isSearchOpen() {
        return !!(searchForm && !searchForm.classList.contains('!hidden'));
      }
      function openSearch() {
        if (!searchForm) return;
        searchForm.classList.remove('!hidden');
        Array.prototype.forEach.call(searchToggleBtns, function(b){
          b.setAttribute('aria-expanded', 'true');
          b.setAttribute('aria-label', 'Close search');
        });
        if (searchInput) {
          searchInput.setAttribute('aria-expanded', 'true');
          try { searchInput.focus({ preventScroll: true }); } catch (_) { searchInput.focus(); }
          // Restore the results panel if a query is already typed.
          if ((searchInput.value || '').trim().length >= minChars && resultsHost && resultsHost.innerHTML.trim()) {
            resultsHost.classList.remove('hidden');
          }
        }
      }
      function closeSearch() {
        if (!searchForm) return;
        searchForm.classList.add('!hidden');
        if (resultsHost) resultsHost.classList.add('hidden');
        Array.prototype.forEach.call(searchToggleBtns, function(b){
          b.setAttribute('aria-expanded', 'false');
          b.setAttribute('aria-label', 'Open search');
        });
        if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
      }
      function handleSearchToggle(e) {
        var t = e.target.closest && e.target.closest('[data-search-toggle]');
        if (!t) return;
        e.preventDefault();
        // Search invoked from inside the menu drawer — close the menu
        // first so the inline bar isn't sitting behind the overlay.
        if (t.hasAttribute('data-search-from-nav') && overlay.classList.contains('is-open')) {
          close();
        }
        if (isSearchOpen()) closeSearch(); else openSearch();
      }
      function handleSearchEsc(e) {
        if (e.key === 'Escape' && isSearchOpen()) closeSearch();
      }
      // Click anywhere outside the form (and not on a toggle) closes the bar.
      function handleOutsideClick(e) {
        if (!isSearchOpen()) return;
        if (searchForm.contains(e.target)) return;
        if (e.target.closest && e.target.closest('[data-search-toggle]')) return;
        closeSearch();
      }

      document.addEventListener('click', handleSearchToggle);
      document.addEventListener('keydown', handleSearchEsc);
      document.addEventListener('click', handleOutsideClick);

      // Predictive search — debounced fetch into the dropdown. Uses
      // Shopify's Section Rendering API so Liquid filters / theme styles
      // flow through unchanged.
      var debounceTimer = null;
      var activeAbort = null;
      var lastQuery = '';

      function resetToHint() {
        if (!resultsHost) return;
        resultsHost.innerHTML = '';
        resultsHost.setAttribute('aria-busy', 'false');
        resultsHost.classList.add('hidden');
      }

      function setBusy(busy) {
        if (resultsHost) resultsHost.setAttribute('aria-busy', busy ? 'true' : 'false');
      }

      function fetchPredictive(query) {
        if (activeAbort) { try { activeAbort.abort(); } catch (_) {} }
        activeAbort = ('AbortController' in window) ? new AbortController() : null;
        setBusy(true);

        var params = new URLSearchParams();
        params.set('q', query);
        params.set('section_id', 'predictive-search');
        params.set('resources[limit]', String(resultsLimit));
        params.set('resources[limit_scope]', 'each');
        params.set('resources[type]', 'product,collection,article,page,query');

        var url = '/search/suggest?' + params.toString();
        return fetch(url, {
          headers: { 'Accept': 'text/html' },
          signal: activeAbort ? activeAbort.signal : undefined
        })
          .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function(html) {
            // Extract the content node so we don't nest a section wrapper
            // on each fetch.
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-predictive-search-content]');
            if (!resultsHost) return;
            if (fresh) {
              resultsHost.innerHTML = '';
              resultsHost.appendChild(fresh);
            } else {
              resultsHost.innerHTML = html;
            }
            // Reveal the dropdown panel — it's hidden by default so it
            // doesn't show an empty "Press Enter…" hint when the bar
            // first opens with no query.
            resultsHost.classList.remove('hidden');
            setBusy(false);
          })
          .catch(function(err) {
            if (err && (err.name === 'AbortError' || err === 'AbortError')) return;
            setBusy(false);
          });
      }

      function handleSearchInput(e) {
        var query = (e.target.value || '').trim();
        if (debounceTimer) clearTimeout(debounceTimer);

        if (query.length < minChars) {
          // Only reset on full clear, not while ramping up to minChars
          // (avoids flicker between typed character and threshold).
          if (query.length === 0 && lastQuery.length > 0) resetToHint();
          lastQuery = query;
          return;
        }

        if (query === lastQuery) return;
        lastQuery = query;

        debounceTimer = setTimeout(function() {
          fetchPredictive(query);
        }, 200);
      }

      if (searchInput) {
        searchInput.addEventListener('input', handleSearchInput);
      }

      root._headerCleanup = function() {
        openBtn.removeEventListener('click', open);
        if (closeBtn) closeBtn.removeEventListener('click', close);
        document.removeEventListener('click', handleSearchToggle);
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('keydown', handleSearchEsc);
        if (searchInput) searchInput.removeEventListener('input', handleSearchInput);
        if (debounceTimer) clearTimeout(debounceTimer);
        if (activeAbort) { try { activeAbort.abort(); } catch (_) {} }
      };
    }

    document.querySelectorAll('[data-section-id]').forEach(initHeader);

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector('[data-section-id]') || event.target;
      initHeader(root);
    });
    document.addEventListener('shopify:section:unload', function(event) {
      var root = event.target.querySelector('[data-section-id]') || event.target;
      if (root && typeof root._headerCleanup === 'function') root._headerCleanup();
    });

    // ----------------------------------------------------------------
    // Light-on-dark variant tracker.
    // When the (transparent, fixed) header is currently overlapping a
    // section marked `data-light-header="true"`, swap the header into its
    // light variant by adding `.is-light`. CSS variables in the section's
    // stylesheet flip the foreground colour + border to a light tone, and
    // the existing `transition-colors` rule animates the swap.
    // ----------------------------------------------------------------
    function updateHeaderVariant() {
      var header = document.querySelector('.site-header');
      if (!header) return;
      var headerHeight = header.offsetHeight || 98;
      var lightSections = document.querySelectorAll('[data-light-header="true"]');
      var isLight = false;
      for (var i = 0; i < lightSections.length; i++) {
        var rect = lightSections[i].getBoundingClientRect();
        // Section is under the header right now if its top has scrolled
        // above the header's bottom edge AND its bottom is still below
        // the viewport top (i.e. the header is currently sitting on it).
        if (rect.top < headerHeight && rect.bottom > 0) {
          isLight = true;
          break;
        }
      }
      if (isLight) {
        header.classList.add('is-light');
      } else {
        header.classList.remove('is-light');
      }
    }
    window.addEventListener('scroll', updateHeaderVariant, { passive: true });
    window.addEventListener('resize', updateHeaderVariant);
    document.addEventListener('shopify:section:load', updateHeaderVariant);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateHeaderVariant);
    } else {
      updateHeaderVariant();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-intro"]) return;
  try {
    
  (function() {
    var STORAGE_KEY = 'mira:page-intro-shown';
    // Hard-coded CDN URL is the last-resort fallback. Production uses the
    // self-hosted copy at assets/gsap.min.js, surfaced via the curtain's
    // data-gsap-src attribute (rendered by Liquid as a Shopify asset URL).
    var GSAP_FALLBACK_SRC = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';

    function getCurtain() { return document.querySelector('[data-page-intro]'); }

    function getLandTarget(curtain) {
      var sel = curtain && curtain.getAttribute('data-land-selector');
      return sel ? document.querySelector(sel) : null;
    }

    function transferToSlot(curtain) {
      if (!curtain) return false;
      var target = getLandTarget(curtain);
      if (!target) {
        // No banner slot — fall back to hiding the curtain so it isn't blocking the page.
        curtain.style.display = 'none';
        document.body.classList.remove('page-intro-locked');
        return false;
      }

      // Drop GSAP-set inline positioning + sizing
      var s = curtain.style;
      s.position = ''; s.top = ''; s.left = ''; s.right = ''; s.bottom = '';
      s.width = '';   s.height = ''; s.transform = ''; s.opacity = '';

      // Swap fixed-full-viewport classes for absolute-fill-parent
      curtain.classList.remove('fixed', 'top-0', 'left-0', 'w-screen', 'h-screen', 'z-[100]');
      curtain.classList.add('absolute', 'inset-0', 'w-full', 'h-full', 'page-intro--in-slot');

      // Move into the slot — prepend so existing CTAs render above the image
      if (target.firstChild) {
        target.insertBefore(curtain, target.firstChild);
      } else {
        target.appendChild(curtain);
      }

      document.documentElement.classList.remove('page-intro-will-run');
      document.body.classList.remove('page-intro-locked');
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
      return true;
    }

    function revealRisers() {
      // Returning visits / reduced-motion / GSAP failure: just unhide risers
      // by clearing the flag class. No animation, instant reveal.
      document.documentElement.classList.remove('page-intro-will-run');
    }

    function loadGsap(cb) {
      if (window.gsap) return cb();
      var curtain = getCurtain();
      var src = (curtain && curtain.getAttribute('data-gsap-src')) || GSAP_FALLBACK_SRC;
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      // IMPORTANT: wrap cb so the load Event isn't passed as cb's first arg.
      // If we did `s.onload = cb`, the browser would call cb(event), which
      // makes `err` truthy in play()'s callback and silently triggers the
      // no-animation fallback even when GSAP loaded perfectly.
      s.onload = function() { cb(); };
      s.onerror = function() {
        // Shopify CDN failed — try the public CDN as a last resort before
        // falling back to no-animation.
        if (src !== GSAP_FALLBACK_SRC) {
          var s2 = document.createElement('script');
          s2.src = GSAP_FALLBACK_SRC;
          s2.async = true;
          s2.onload = function() { cb(); };
          s2.onerror = function() { cb(new Error('gsap-load-failed')); };
          document.head.appendChild(s2);
        } else {
          cb(new Error('gsap-load-failed'));
        }
      };
      document.head.appendChild(s);
    }

    function play(curtain) {
      var slideDur = (parseInt(curtain.getAttribute('data-slide-duration'), 10) || 1100) / 1000;
      var riseDur = (parseInt(curtain.getAttribute('data-rise-duration'), 10) || 1200) / 1000;
      var riseDist = parseInt(curtain.getAttribute('data-rise-distance'), 10) || 200;
      var imageHoldSec = (parseInt(curtain.getAttribute('data-image-hold'), 10) || 0) / 1000;
      var fxItems = curtain.querySelectorAll('[data-page-intro-fx]');
      var counterEl = curtain.querySelector('[data-page-intro-counter]');

      loadGsap(function(err) {
        if (err || !window.gsap) {
          // Graceful fallback: skip animation entirely, but still drop the curtain
          // into the banner slot so the image is visible at the banner location.
          revealRisers();
          transferToSlot(curtain);
          return;
        }

        var gsap = window.gsap;
        var risers = document.querySelectorAll('[data-page-intro-rise]');
        var tl = gsap.timeline({ onComplete: function() { transferToSlot(curtain); } });

        // 1. Fade brand + counter IN
        tl.to(fxItems, {
          opacity: 1,
          duration: 1.0,
          ease: 'power2.out',
          stagger: 0.05
        });

        // 2. Counter ticks 0 → 100 in parallel with the fade-in
        if (counterEl) {
          var ctr = { v: 0 };
          tl.to(ctr, {
            v: 100,
            duration: 1.1,
            ease: 'expo.inOut',
            onUpdate: function() { counterEl.textContent = String(Math.round(ctr.v)); }
          }, 0);
        }

        // 3. Anchor the exit phase right after the fade-in completes (no hold).
        tl.addLabel('exit');

        // 4. Fade brand OUT (0.5s)
        tl.to(fxItems, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out',
          stagger: 0.04
        }, 'exit');

        // 5. Anchor the slide phase to an ABSOLUTE timeline position so the
        // setting is the literal time from intro start to slide start. Brand
        // fade-in (1.0s) + counter (1.1s) run in parallel and no longer block
        // the slide — set the value low (e.g. 100ms) for a snappy slide that
        // overlaps the brand phase, or high (1100+) to let the brand fully
        // show first.
        var slideAt = imageHoldSec;

        // 6. In parallel with the curtain exit: rise the heading + any other
        // [data-page-intro-rise] targets up into their natural position.
        // CSS sets the offset before paint to avoid a flash, but we also force
        // the initial state via gsap.set() so the tween's start values are
        // unambiguous regardless of CSS specificity / load timing.
        if (risers.length) {
          gsap.set(risers, { opacity: 0, y: riseDist, force3D: true });
          tl.to(risers, {
            opacity: 1,
            y: 0,
            duration: riseDur,
            ease: 'power3.out',
            stagger: 0.08,
            onStart: function() {
              // Drop the flag so when GSAP finishes the natural styles take over
              // (no transform, no opacity override) without any visible jump.
              document.documentElement.classList.remove('page-intro-will-run');
            },
            onComplete: function() {
              // Clear inline transform/opacity so the element sits at its native style.
              gsap.set(risers, { clearProps: 'transform,opacity,willChange' });
            }
          }, slideAt);
        }

        // 7. Curtain slides down and lands on the banner's bounding rect. If no
        // land target is found, just slide off-screen as a last-resort fallback.
        // Either way, transferToSlot() runs in onComplete so the image ends up
        // living inside the banner slot.
        var target = getLandTarget(curtain);
        if (target) {
          tl.to(curtain, {
            top: function() { return target.getBoundingClientRect().top + 'px'; },
            left: function() { return target.getBoundingClientRect().left + 'px'; },
            width: function() { return target.getBoundingClientRect().width + 'px'; },
            height: function() { return target.getBoundingClientRect().height + 'px'; },
            duration: slideDur,
            ease: 'power3.inOut'
          }, slideAt);
        } else {
          tl.to(curtain, {
            yPercent: 100,
            duration: slideDur,
            ease: 'power3.inOut'
          }, slideAt);
        }
      });
    }

    function getLoader() { return document.querySelector('[data-page-intro-loader]'); }

    function hideLoader(then) {
      var loader = getLoader();
      if (!loader) { then(); return; }
      // CSS transition (`.page-intro-loader { transition: opacity 0.4s ease-out }`)
      // handles the visual fade — no GSAP dependency, so non-home pages don't need
      // to download the GSAP bundle just for the loader.
      loader.style.opacity = '0';
      setTimeout(function() {
        loader.style.display = 'none';
        then();
      }, 400);
    }

    function start() {
      var loader = getLoader();
      var curtain = getCurtain();
      if (!loader && !curtain) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Reduced motion: skip both loader animation and curtain animation. If the
      // curtain exists drop it straight into the banner slot so the image is
      // still visible at the banner location.
      if (reduced) {
        if (loader) loader.style.display = 'none';
        if (curtain) {
          revealRisers();
          transferToSlot(curtain);
        }
        return;
      }

      // Lock body scroll throughout. It gets unlocked either by transferToSlot()
      // (curtain path) or by proceedAfterLoader() directly (non-home path).
      document.body.classList.add('page-intro-locked');

      // Hold the loader until BOTH (a) window.load has fired (all assets fetched)
      // AND (b) at least loaderMinMs has elapsed since this run started. The min
      // duration is a merchant-controlled floor so the loader doesn't vanish
      // instantly on cached / fast loads.
      var loaderMinMs = loader
        ? (parseInt(loader.getAttribute('data-loader-min'), 10) || 0)
        : 0;
      var startTime = Date.now();
      var loadDone = false;
      var fired = false;

      function proceedAfterLoader() {
        if (!curtain) {
          // Non-home page: loader is gone, page is ready. Just unlock scroll.
          document.body.classList.remove('page-intro-locked');
          return;
        }

        // Home page: check whether the curtain has already played this session.
        var once = curtain.getAttribute('data-once') === 'true';
        var sessionShown = false;
        try {
          sessionShown = once && sessionStorage.getItem(STORAGE_KEY) === '1';
        } catch (e) { /* sessionStorage blocked — let curtain run */ }

        if (sessionShown) {
          // Skip the curtain animation but still drop it into the banner slot.
          revealRisers();
          transferToSlot(curtain);
          return;
        }

        // First home visit: play the curtain timeline. transferToSlot() runs
        // on its onComplete and unlocks scroll there.
        play(curtain);
      }

      function maybeFire() {
        if (fired || !loadDone) return;
        var elapsed = Date.now() - startTime;
        if (elapsed < loaderMinMs) {
          setTimeout(maybeFire, loaderMinMs - elapsed);
          return;
        }
        fired = true;
        if (loader) {
          hideLoader(proceedAfterLoader);
        } else {
          proceedAfterLoader();
        }
      }

      function onLoad() {
        loadDone = true;
        maybeFire();
      }

      if (document.readyState === 'complete') {
        onLoad();
      } else {
        window.addEventListener('load', onLoad);
        // Safety net: don't keep the loader up forever if something stalls.
        setTimeout(onLoad, 6000);
      }
    }

    // Run as early as possible. The element is inline above the rest of the page,
    // so the curtain paints with the first frame; JS just orchestrates the exit.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    // Theme editor: replay the intro when the merchant edits its settings
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector && event.target.querySelector('[data-page-intro]')) {
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
        start();
      }
    });
  })();

  // -------------------------------------------------------------------------
  // Global reveal-on-scroll observer.
  // Watches every [data-reveal] element on the page and adds .is-revealed
  // when it scrolls into view (after an optional data-reveal-delay in ms).
  // One-shot per element.
  //
  // Auto-handles dynamically-injected content (Load More, AJAX section
  // updates, etc.) via a MutationObserver — sections that append new
  // [data-reveal] elements after page load don't need any wiring.
  //
  // Lives in page-intro.liquid because page-intro is statically mounted via
  // layout/theme.liquid and so its {% javascript %} bundle loads on every
  // page — the observer is therefore globally available without duplicating
  // code into every section that wants to opt in.
  // -------------------------------------------------------------------------
  (function() {
    var REVEAL_OPTS = { threshold: 0.15, rootMargin: '0px 0px -10% 0px' };

    function revealNow(el) {
      var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
      if (delay > 0) {
        setTimeout(function() { el.classList.add('is-revealed'); }, delay);
      } else {
        el.classList.add('is-revealed');
      }
    }

    // Single long-lived IntersectionObserver — reused across all
    // observeReveals() calls so dynamically-added elements join the same
    // observer instance instead of creating new ones.
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            revealNow(entry.target);
            io.unobserve(entry.target);
          });
        }, REVEAL_OPTS)
      : null;

    function observeReveals(scope) {
      var root = scope || document;

      // Collect [data-reveal] elements at and below `root`. We include `root`
      // itself when it matches because dynamically-added elements often ARE
      // the reveal target (not just a container of one).
      var hostMatches = root.matches && root.matches('[data-reveal]:not(.is-revealed)');
      var inner = root.querySelectorAll
        ? root.querySelectorAll('[data-reveal]:not(.is-revealed)')
        : [];
      var total = inner.length + (hostMatches ? 1 : 0);
      if (!total) return;

      if (!io) {
        // No IntersectionObserver support → reveal everything immediately.
        if (hostMatches) root.classList.add('is-revealed');
        inner.forEach(function(el) { el.classList.add('is-revealed'); });
        return;
      }

      if (hostMatches) io.observe(root);
      inner.forEach(function(el) { io.observe(el); });
    }

    // Initial pass.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { observeReveals(); });
    } else {
      observeReveals();
    }

    // Theme editor: re-scan when sections re-render.
    document.addEventListener('shopify:section:load', function(event) {
      observeReveals(event.target);
    });

    // Dynamic content: auto-observe any [data-reveal] elements injected into
    // the DOM after page load. Covers Load More buttons that append more
    // product cards, AJAX-loaded blog posts, etc., without per-section JS.
    if ('MutationObserver' in window) {
      var domWatcher = new MutationObserver(function(mutations) {
        for (var m = 0; m < mutations.length; m++) {
          var added = mutations[m].addedNodes;
          for (var n = 0; n < added.length; n++) {
            var node = added[n];
            if (node.nodeType === 1) observeReveals(node);
          }
        }
      });
      // Observe lazily (after first paint) to avoid noise during initial render.
      if (document.body) {
        domWatcher.observe(document.body, { childList: true, subtree: true });
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          domWatcher.observe(document.body, { childList: true, subtree: true });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'mira:popup-shown';

    function initPopup(root) {
      if (!root || root._popupBound) return;
      root._popupBound = true;

      var delay = parseInt(root.getAttribute('data-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 0;
      var once = root.getAttribute('data-once') === 'true';

      function open() {
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.body.classList.add('popup-open');
      }

      function close() {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('popup-open');
        if (once) {
          try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        }
      }

      function maybeShow() {
        if (once) {
          try { if (localStorage.getItem(STORAGE_KEY)) return; } catch (e) {}
        }
        if (delay > 0) {
          setTimeout(open, delay);
        } else {
          open();
        }
      }

      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-popup-close]')) close();
      });

      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });

      if (window.Shopify && window.Shopify.designMode) {
        open();
        return;
      }

      maybeShow();

      root._popupCleanup = function () {
        close();
        document.body.classList.remove('popup-open');
      };
    }

    var el = document.querySelector('[id^="site-popup-"]');
    if (el) initPopup(el);

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector && e.target.querySelector('[id^="site-popup-"]');
      if (el) { el._popupBound = false; initPopup(el); }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector && e.target.querySelector('[id^="site-popup-"]');
      if (el && typeof el._popupCleanup === 'function') el._popupCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    function init(root) {
      if (!root) return;

      // ===== Image gallery (prev/next arrows + variant-driven jumps) =====
      // Defined first so the variant handler below can call showSlide.
      var gallery = root.querySelector('[data-product-gallery]');
      var showSlide = null;
      if (gallery) {
        var slides = gallery.querySelectorAll('[data-gallery-slide]');
        var prevBtn = gallery.querySelector('[data-gallery-prev]');
        var nextBtn = gallery.querySelector('[data-gallery-next]');
        var currentSlide = 0;

        showSlide = function(index) {
          if (slides.length === 0) return;
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;
          Array.prototype.forEach.call(slides, function(slide, i) {
            var active = i === index;
            slide.classList.toggle('opacity-0', !active);
            slide.classList.toggle('pointer-events-none', !active);
          });
          currentSlide = index;
        };

        if (prevBtn) {
          prevBtn.addEventListener('click', function() { showSlide(currentSlide - 1); });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function() { showSlide(currentSlide + 1); });
        }
      }

      // ===== Price + add-to-cart + track-indicator + image sync on variant change =====
      var priceEl = root.querySelector('[data-product-price]');
      var addToCartBtn = root.querySelector('button[type="submit"]');
      var variantRadios = root.querySelectorAll('input[name="id"][type="radio"]');
      var indicator = root.querySelector('[data-variant-indicator]');
      if (variantRadios.length > 0) {
        function syncVariantState() {
          var checked = root.querySelector('input[name="id"][type="radio"]:checked');
          if (!checked) return;
          if (priceEl && checked.dataset.variantPrice) {
            priceEl.textContent = checked.dataset.variantPrice;
          }
          if (addToCartBtn) {
            var available = checked.dataset.variantAvailable === 'true';
            addToCartBtn.disabled = !available;
            if (available) {
              addToCartBtn.removeAttribute('aria-disabled');
            } else {
              addToCartBtn.setAttribute('aria-disabled', 'true');
            }
          }
          if (indicator && checked.dataset.variantIndex !== undefined) {
            indicator.style.setProperty('--variant-position', checked.dataset.variantIndex);
          }
          // Variant has a featured image assigned in admin → jump the gallery
          // to that slide. Variants with no assigned image leave the gallery
          // untouched (so cycling through colorless variants doesn't kick the
          // user back to image #1).
          if (showSlide && checked.dataset.variantImagePosition !== undefined) {
            var pos = parseInt(checked.dataset.variantImagePosition, 10);
            if (!isNaN(pos)) showSlide(pos);
          }
        }
        Array.prototype.forEach.call(variantRadios, function(radio) {
          radio.addEventListener('change', syncVariantState);
        });
        // Apply initial indicator position from the server-rendered checked variant
        syncVariantState();
      }

      // ===== Related products carousel (prev/next + progress) =====
      var relatedTrack = root.querySelector('[data-related-track]');
      if (relatedTrack) {
        var relatedPrev = root.querySelector('[data-related-prev]');
        var relatedNext = root.querySelector('[data-related-next]');
        var relatedProgress = root.querySelector('[data-related-progress]');

        function relCardStep() {
          var first = relatedTrack.firstElementChild;
          if (!first) return relatedTrack.clientWidth;
          var styles = getComputedStyle(relatedTrack);
          var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
          return first.getBoundingClientRect().width + gap;
        }

        function relVisibleCount() {
          var step = relCardStep();
          return step > 0 ? Math.max(1, Math.round(relatedTrack.clientWidth / step)) : 1;
        }

        function relSetsCount() {
          var total = relatedTrack.children.length;
          return Math.max(1, Math.ceil(total / relVisibleCount()));
        }

        function relUpdate() {
          var sets = relSetsCount();
          var max = relatedTrack.scrollWidth - relatedTrack.clientWidth;
          var ratio = max > 0 ? relatedTrack.scrollLeft / max : 0;
          var current = sets > 1 ? Math.round(ratio * (sets - 1)) : 0;
          if (relatedProgress) {
            relatedProgress.style.width = (100 / sets) + '%';
            relatedProgress.style.left = (current * 100 / sets) + '%';
          }
        }

        function relScrollToSet(index) {
          var sets = relSetsCount();
          if (sets <= 1) return;
          var max = relatedTrack.scrollWidth - relatedTrack.clientWidth;
          var wrapped = ((index % sets) + sets) % sets;
          relatedTrack.scrollTo({ left: (wrapped / (sets - 1)) * max, behavior: 'smooth' });
        }

        function relCurrentSetIndex() {
          var sets = relSetsCount();
          var max = relatedTrack.scrollWidth - relatedTrack.clientWidth;
          var ratio = max > 0 ? relatedTrack.scrollLeft / max : 0;
          return sets > 1 ? Math.round(ratio * (sets - 1)) : 0;
        }

        if (relatedPrev) relatedPrev.addEventListener('click', function() { relScrollToSet(relCurrentSetIndex() - 1); });
        if (relatedNext) relatedNext.addEventListener('click', function() { relScrollToSet(relCurrentSetIndex() + 1); });
        relatedTrack.addEventListener('scroll', relUpdate, { passive: true });
        window.addEventListener('resize', relUpdate);
        relUpdate();
      }

      // ===== Quantity selector =====
      var qtyInput = root.querySelector('[data-qty-input]');
      var qtyDec = root.querySelector('[data-qty-decrement]');
      var qtyInc = root.querySelector('[data-qty-increment]');
      if (qtyInput && qtyDec && qtyInc) {
        qtyDec.addEventListener('click', function() {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
        });
        qtyInc.addEventListener('click', function() {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = v + 1;
        });
      }

      // ===== Add to cart — AJAX, opens drawer instead of navigating =====
      // The Liquid {% form 'product' %} renders <form action="/cart/add" method="post">
      // which by default redirects to /cart on submit. Intercept and POST to
      // /cart/add.js, then dispatch cart:updated — the global cart drawer listens
      // and rerenders + opens itself (sections/cart-drawer.liquid).
      var addForm = root.querySelector('form[action$="/cart/add"]');
      if (addForm) {
        addForm.addEventListener('submit', function(e) {
          e.preventDefault();
          if (addToCartBtn && addToCartBtn.getAttribute('data-state') === 'loading') return;
          if (addToCartBtn) addToCartBtn.setAttribute('data-state', 'loading');

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(addForm)
          })
          .then(function(r) {
            if (!r.ok) {
              return r.json().then(function(d) {
                throw new Error((d && (d.description || d.message)) || ('Add to cart failed: ' + r.status));
              });
            }
            return r.json();
          })
          .then(function() {
            if (addToCartBtn) addToCartBtn.removeAttribute('data-state');
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function(err) {
            console.error('[product] add-to-cart failed:', err);
            if (addToCartBtn) {
              addToCartBtn.removeAttribute('data-state');
              var msg = (err && err.message) || 'Could not add to cart';
              addToCartBtn.setAttribute('title', msg);
              setTimeout(function() { addToCartBtn.removeAttribute('title'); }, 4000);
            }
          });
        });
      }
    }

    document.querySelectorAll('[data-section-id][id^="product-section-"]').forEach(init);
    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector('[data-section-id]') || event.target;
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view-modal"]) return;
  try {
    
  (function() {
    var modal, panel, gallery, titleEl, priceEl, optionsEl, descEl, qtyEl,
        decBtn, incBtn, addBtn, errorEl;
    var ADD_LABEL, LOADING_LABEL, ERROR_LABEL;

    var currentProduct = null;
    var currentVariant = null;
    var currentImageIndex = 0;

    function el(tag, attrs, html) {
      var n = document.createElement(tag);
      if (attrs) {
        Object.keys(attrs).forEach(function(k) {
          if (k === 'class') n.className = attrs[k];
          else if (k === 'dataset') {
            Object.keys(attrs[k]).forEach(function(dk) { n.dataset[dk] = attrs[k][dk]; });
          }
          else n.setAttribute(k, attrs[k]);
        });
      }
      if (html != null) n.innerHTML = html;
      return n;
    }

    function init() {
      modal = document.querySelector('[data-quick-view-modal]');
      if (!modal) return;
      panel = modal.querySelector('[data-quick-view-panel]');
      gallery = modal.querySelector('[data-quick-view-gallery]');
      titleEl = modal.querySelector('[data-quick-view-title]');
      priceEl = modal.querySelector('[data-quick-view-price]');
      optionsEl = modal.querySelector('[data-quick-view-options]');
      descEl = modal.querySelector('[data-quick-view-description]');
      qtyEl = modal.querySelector('[data-quick-view-qty]');
      decBtn = modal.querySelector('[data-quick-view-qty-decrement]');
      incBtn = modal.querySelector('[data-quick-view-qty-increment]');
      addBtn = modal.querySelector('[data-quick-view-add]');
      errorEl = modal.querySelector('[data-quick-view-error]');

      ADD_LABEL = modal.getAttribute('data-add-to-cart-label') || 'ADD TO BAG';
      LOADING_LABEL = modal.getAttribute('data-loading-label') || 'Loading…';
      ERROR_LABEL = modal.getAttribute('data-error-label') || 'Could not load product.';

      bindStaticEvents();
    }

    function open() {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('quick-view-open');
    }

    function close() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('quick-view-open');
    }

    function showError() {
      if (errorEl) errorEl.removeAttribute('hidden');
    }
    function hideError() {
      if (errorEl) errorEl.setAttribute('hidden', '');
    }

    function resetSkeleton() {
      hideError();
      if (titleEl) titleEl.textContent = LOADING_LABEL;
      if (priceEl) priceEl.textContent = '';
      if (gallery) gallery.innerHTML = '';
      if (optionsEl) optionsEl.innerHTML = '';
      if (descEl) descEl.innerHTML = '';
      if (qtyEl) qtyEl.value = '1';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.dataset.state = '';
      }
      currentProduct = null;
      currentVariant = null;
      currentImageIndex = 0;
    }

    function loadProduct(handle) {
      resetSkeleton();
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function(product) {
          currentProduct = product;
          // Default selected variant = first available, or first variant if all sold out.
          var firstAvail = null;
          for (var i = 0; i < product.variants.length; i++) {
            if (product.variants[i].available) { firstAvail = product.variants[i]; break; }
          }
          currentVariant = firstAvail || product.variants[0];
          render();
        })
        .catch(function() {
          if (titleEl) titleEl.textContent = '';
          showError();
        });
    }

    function render() {
      if (!currentProduct) return;
      titleEl.textContent = currentProduct.title;
      descEl.innerHTML = currentProduct.description || '';

      renderGallery();
      renderOptions();
      syncVariantUI();
    }

    function renderGallery() {
      gallery.innerHTML = '';
      var images = (currentProduct.images && currentProduct.images.length) ? currentProduct.images : [];
      if (images.length === 0) {
        var ph = el('div', { class: 'w-full aspect-square bg-gradient-to-br from-[#3A688E] to-[#123A60]' });
        gallery.appendChild(ph);
        return;
      }
      images.forEach(function(src, i) {
        var slide = el('div', {
          class: 'quick-view-modal__slide' + (i === 0 ? ' is-active' : ''),
          dataset: { quickViewSlide: String(i) }
        });
        var img = el('img', {
          src: src,
          alt: currentProduct.title,
          loading: i === 0 ? 'eager' : 'lazy'
        });
        slide.appendChild(img);
        gallery.appendChild(slide);
      });
      currentImageIndex = 0;

      if (images.length > 1) {
        var prev = el('button', { type: 'button', class: 'quick-view-modal__nav quick-view-modal__nav--prev', 'aria-label': 'Previous image' },
          '<svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6.5 0.5L0.5 7L6.5 13.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>');
        var next = el('button', { type: 'button', class: 'quick-view-modal__nav quick-view-modal__nav--next', 'aria-label': 'Next image' },
          '<svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M0.5 0.5L6.5 7L0.5 13.5" stroke="currentColor" stroke-width="1.5" fill="none"/></svg>');
        prev.addEventListener('click', function() { showSlide(currentImageIndex - 1); });
        next.addEventListener('click', function() { showSlide(currentImageIndex + 1); });
        gallery.appendChild(prev);
        gallery.appendChild(next);
      }
    }

    function showSlide(idx) {
      if (!currentProduct) return;
      var images = currentProduct.images || [];
      if (!images.length) return;
      var n = images.length;
      var next = ((idx % n) + n) % n;
      var slides = gallery.querySelectorAll('.quick-view-modal__slide');
      slides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === next);
      });
      currentImageIndex = next;
    }

    function renderOptions() {
      optionsEl.innerHTML = '';
      // For single-default-variant products the JSON still includes options
      // (["Title"]) and a single variant titled "Default Title" — skip the
      // picker UI in that case.
      var hasOnlyDefault = currentProduct.variants.length === 1
        && currentProduct.variants[0].title === 'Default Title';
      if (hasOnlyDefault) return;

      currentProduct.options.forEach(function(opt, optIdx) {
        // Shopify's /products/<handle>.js returns options as either an array of
        // strings or an array of {name, position, values} objects. Only the
        // name is used here — purely for the aria-label on the radio group, no
        // visible legend.
        var optName = (typeof opt === 'string') ? opt
          : (opt && opt.name) ? opt.name
          : ('Option ' + (optIdx + 1));
        var fieldset = el('fieldset', { class: 'm-0 p-0 border-0 flex flex-col gap-[8px]' });
        var group = el('div', { class: 'flex flex-row flex-wrap gap-[8px]', role: 'radiogroup', 'aria-label': optName });

        // Collect unique values for this option in source order.
        var seen = {};
        var values = [];
        currentProduct.variants.forEach(function(v) {
          var val = v.options[optIdx];
          if (!seen[val]) { seen[val] = true; values.push(val); }
        });

        values.forEach(function(value) {
          // A value is selectable if at least one available variant uses it
          // combined with the currently-selected values for other options.
          var matchingVariant = findVariantForOptionChange(optIdx, value);
          var available = !!(matchingVariant && matchingVariant.available);
          var selected = currentVariant && currentVariant.options[optIdx] === value;
          var btn = el('button', {
            type: 'button',
            class: 'quick-view-variant',
            role: 'radio',
            dataset: { quickViewOption: String(optIdx), quickViewValue: value },
            'aria-checked': selected ? 'true' : 'false'
          }, value);
          if (!available) {
            btn.setAttribute('disabled', '');
            btn.setAttribute('aria-disabled', 'true');
          }
          btn.addEventListener('click', function() { selectOption(optIdx, value); });
          group.appendChild(btn);
        });

        fieldset.appendChild(group);
        optionsEl.appendChild(fieldset);
      });
    }

    // Given a current variant and a proposed option change, find the variant
    // whose option array matches. Prefer an available one, else fall back to
    // any matching variant (so the user can still select it and see the
    // sold-out state).
    function findVariantForOptionChange(optIdx, newValue) {
      if (!currentProduct || !currentVariant) return null;
      var target = currentVariant.options.slice();
      target[optIdx] = newValue;
      var fallback = null;
      for (var i = 0; i < currentProduct.variants.length; i++) {
        var v = currentProduct.variants[i];
        var match = true;
        for (var j = 0; j < target.length; j++) {
          if (v.options[j] !== target[j]) { match = false; break; }
        }
        if (match) {
          if (v.available) return v;
          if (!fallback) fallback = v;
        }
      }
      return fallback;
    }

    function selectOption(optIdx, value) {
      var nextVariant = findVariantForOptionChange(optIdx, value);
      if (!nextVariant) return;
      currentVariant = nextVariant;
      // Re-render option pills so availability flags pick up the new context.
      renderOptions();
      syncVariantUI();
    }

    // Find the index of a variant's featured image inside product.images.
    // Tries position first (1-indexed in Shopify's product.js, most reliable
    // when available), then falls back to a normalised URL comparison —
    // strict `===` fails when Shopify emits the same image with different
    // protocols (https: vs //) or trailing query params (?v=…, ?width=…).
    function findVariantImageIndex(variant, productImages) {
      if (!variant || !variant.featured_image || !productImages || !productImages.length) return -1;
      var fi = variant.featured_image;
      if (typeof fi === 'object' && typeof fi.position === 'number') {
        var posIdx = fi.position - 1;
        if (posIdx >= 0 && posIdx < productImages.length) return posIdx;
      }
      var url = typeof fi === 'string' ? fi : fi.src;
      if (!url) return -1;
      function normalise(u) {
        return String(u || '').replace(/^https?:/, '').split('?')[0];
      }
      var target = normalise(url);
      for (var i = 0; i < productImages.length; i++) {
        if (normalise(productImages[i]) === target) return i;
      }
      return -1;
    }

    function syncVariantUI() {
      if (!currentVariant) return;
      // Price
      priceEl.textContent = formatMoney(currentVariant.price);

      // Swap gallery image to the variant's featured image if any.
      var imgIdx = findVariantImageIndex(currentVariant, currentProduct.images);
      if (imgIdx >= 0) showSlide(imgIdx);

      // CTA state
      if (currentVariant.available) {
        addBtn.disabled = false;
        addBtn.dataset.state = '';
      } else {
        addBtn.disabled = true;
        addBtn.dataset.state = 'soldout';
      }
    }

    // Mirror Shopify's money output. We don't have shop.money_format on the
    // client, so use Intl with the documented shop currency if exposed via
    // window.Shopify.currency.active, otherwise fall back to the raw value.
    function formatMoney(cents) {
      try {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: window.Shopify.currency.active
          }).format(cents / 100);
        }
      } catch (e) {}
      return (cents / 100).toFixed(2);
    }

    function addToCart() {
      if (!currentVariant || !currentVariant.available) return;
      var qty = parseInt(qtyEl.value, 10);
      if (!qty || qty < 1) qty = 1;
      addBtn.dataset.state = 'loading';
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: currentVariant.id, quantity: qty }] })
      })
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function() {
          addBtn.dataset.state = 'success';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            close();
            // After the modal's close transition begins, also reset the CTA
            // for the next open.
            setTimeout(function() {
              if (addBtn) addBtn.dataset.state = '';
            }, 600);
          }, 700);
        })
        .catch(function() {
          addBtn.dataset.state = '';
          addBtn.disabled = !(currentVariant && currentVariant.available);
          showError();
        });
    }

    function bindStaticEvents() {
      // Close
      modal.querySelectorAll('[data-quick-view-close]').forEach(function(b) {
        b.addEventListener('click', function(e) { e.preventDefault(); close(); });
      });

      // Qty +/-
      if (decBtn) decBtn.addEventListener('click', function() {
        var v = parseInt(qtyEl.value, 10) || 1;
        qtyEl.value = String(Math.max(1, v - 1));
      });
      if (incBtn) incBtn.addEventListener('click', function() {
        var v = parseInt(qtyEl.value, 10) || 1;
        qtyEl.value = String(v + 1);
      });

      // Add to cart
      if (addBtn) addBtn.addEventListener('click', function(e) {
        e.preventDefault();
        addToCart();
      });
    }

    // Global trigger — any [data-quick-view] opens the modal for that handle.
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest && e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = trigger.getAttribute('data-quick-view');
      if (!handle) return;
      open();
      loadProduct(handle);
    });

    // Esc closes
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
    });

    // shopify:section:load — re-init if the editor reloads this section's markup.
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector && event.target.querySelector('[data-quick-view-modal]')) {
        init();
      }
    });

    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    function init(root) {
      if (!root) return;
      var toggle = root.querySelector('[data-filters-toggle]');
      var overlay = root.querySelector('[data-filter-overlay]');
      if (!toggle || !overlay) return;

      var closeEls = root.querySelectorAll('[data-filter-close]');

      function openOverlay() {
        overlay.classList.add('is-open');
        overlay.classList.remove('hidden');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('filter-overlay-open');
      }
      function closeOverlay() {
        overlay.classList.remove('is-open');
        overlay.classList.add('hidden');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('filter-overlay-open');
      }
      function onEsc(e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
      }

      toggle.addEventListener('click', openOverlay);
      Array.prototype.forEach.call(closeEls, function(b) { b.addEventListener('click', closeOverlay); });
      document.addEventListener('keydown', onEsc);

      // Live filtering: fetch + swap on change, no full reload.
      // Mirrors the pattern in collection-category.liquid.
      var grid = root.querySelector('[data-product-grid]');
      var counter = root.querySelector('[data-product-counter]');
      var loadMore = root.querySelector('[data-load-more]');
      var filterForm = overlay.querySelector('[data-filter-form]');
      var filterAbort = null;
      var filterTimer = null;

      function refreshApplyHidden() {
        var applyBtn = filterForm && filterForm.querySelector('button[type="submit"]');
        if (applyBtn) applyBtn.classList.add('hidden');
        initPriceRanges();
      }

      function initPriceRanges() {
        if (!filterForm) return;
        filterForm.querySelectorAll('[data-price-range]').forEach(function(root) {
          if (root._priceInit) return;
          root._priceInit = true;
          var minInput = root.querySelector('[data-price-min]');
          var maxInput = root.querySelector('[data-price-max]');
          var minDisplay = root.querySelector('[data-price-min-display]');
          var maxDisplay = root.querySelector('[data-price-max-display]');
          var fill = root.querySelector('[data-price-fill]');
          var currency = root.getAttribute('data-currency') || '';
          var max = parseInt(root.getAttribute('data-range-max'), 10) || 1;
          if (!minInput || !maxInput) return;

          function paint() {
            var lo = parseInt(minInput.value, 10);
            var hi = parseInt(maxInput.value, 10);
            if (lo > hi) {
              if (this === minInput) { minInput.value = hi; lo = hi; }
              else { maxInput.value = lo; hi = lo; }
            }
            if (minDisplay) minDisplay.textContent = currency + ' ' + lo + '.00';
            if (maxDisplay) maxDisplay.textContent = currency + ' ' + hi + '.00';
            if (fill) {
              fill.style.left = (lo / max * 100) + '%';
              fill.style.right = (100 - hi / max * 100) + '%';
            }
          }
          minInput.addEventListener('input', paint);
          maxInput.addEventListener('input', paint);
          paint();
        });
      }

      function buildFilterURL() {
        if (!filterForm) return null;
        var fd = new FormData(filterForm);
        var params = new URLSearchParams();
        fd.forEach(function(value, key) {
          if (value !== '' && value != null) params.append(key, value);
        });
        var qs = params.toString();
        return filterForm.action + (qs ? '?' + qs : '');
      }

      function setFilterBusy(busy) {
        if (!filterForm) return;
        filterForm.setAttribute('aria-busy', busy ? 'true' : 'false');
        filterForm.style.opacity = busy ? '0.6' : '';
        filterForm.style.pointerEvents = busy ? 'none' : '';
      }

      function applyFiltersTo(url, opts) {
        if (!url || !filterForm) return;
        opts = opts || {};

        if (filterAbort) { try { filterAbort.abort(); } catch (_) {} }
        filterAbort = ('AbortController' in window) ? new AbortController() : null;
        setFilterBusy(true);

        fetch(url, {
          headers: { 'Accept': 'text/html' },
          signal: filterAbort ? filterAbort.signal : undefined
        })
          .then(function(r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            // -- Product grid -----------------------------------------
            var freshGrid = doc.querySelector('[data-product-grid]');
            if (grid && freshGrid) {
              grid.replaceWith(freshGrid);
              grid = freshGrid;
            }

            // -- Counter ----------------------------------------------
            var freshCounter = doc.querySelector('[data-product-counter]');
            var liveCounter = root.querySelector('[data-product-counter]');
            if (liveCounter && freshCounter) {
              liveCounter.textContent = freshCounter.textContent.trim();
              counter = liveCounter;
            }

            // -- Load more --------------------------------------------
            var freshLoadMore = doc.querySelector('[data-load-more]');
            var liveLoadMore = root.querySelector('[data-load-more]');
            if (liveLoadMore && freshLoadMore) {
              liveLoadMore.href = freshLoadMore.getAttribute('href') || '';
              liveLoadMore.textContent = freshLoadMore.textContent.trim();
              loadMore = liveLoadMore;
            } else if (liveLoadMore && !freshLoadMore) {
              liveLoadMore.remove();
              loadMore = null;
            }

            // -- Filter form (counts + active states + price values) --
            var freshForm = doc.querySelector('[data-filter-form]');
            if (freshForm && filterForm) {
              var openStates = [];
              filterForm.querySelectorAll('details.filter-group').forEach(function(d) {
                openStates.push(d.open);
              });
              var focusedName = null;
              var ae = document.activeElement;
              if (ae && filterForm.contains(ae) && ae.name) {
                focusedName = ae.name;
              }

              filterForm.innerHTML = freshForm.innerHTML;

              filterForm.querySelectorAll('details.filter-group').forEach(function(d, i) {
                if (typeof openStates[i] === 'boolean') d.open = openStates[i];
              });
              if (focusedName) {
                var refocus = filterForm.querySelector('[name="' + focusedName + '"]');
                if (refocus) {
                  refocus.focus({ preventScroll: true });
                  if (refocus.value != null) {
                    var v = refocus.value;
                    try { refocus.setSelectionRange(v.length, v.length); } catch (_) {}
                  }
                }
              }
              refreshApplyHidden();
            }

            // -- URL --------------------------------------------------
            if (!opts.skipPushState) {
              history.pushState({ filtersApplied: true }, '', url);
            }
            setFilterBusy(false);
          })
          .catch(function(err) {
            if (err && (err.name === 'AbortError' || err === 'AbortError')) return;
            setFilterBusy(false);
          });
      }

      function debouncedApply(ms) {
        if (filterTimer) clearTimeout(filterTimer);
        filterTimer = setTimeout(function() {
          applyFiltersTo(buildFilterURL());
        }, ms || 0);
      }

      function onFilterChange(e) {
        var t = e.target;
        if (t && (t.type === 'checkbox' || t.type === 'radio' || t.type === 'range')) debouncedApply(0);
      }
      function onFilterInput(e) {
        var t = e.target;
        if (t && t.type === 'number') debouncedApply(500);
      }
      function onFilterSubmit(e) { e.preventDefault(); applyFiltersTo(buildFilterURL()); }
      function onFilterClick(e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (a && filterForm.contains(a)) {
          e.preventDefault();
          applyFiltersTo(a.href);
        }
      }
      function onFilterPopState() { applyFiltersTo(window.location.href, { skipPushState: true }); }

      if (filterForm) {
        refreshApplyHidden();
        filterForm.addEventListener('change', onFilterChange);
        filterForm.addEventListener('input', onFilterInput);
        filterForm.addEventListener('submit', onFilterSubmit);
        filterForm.addEventListener('click', onFilterClick);
        window.addEventListener('popstate', onFilterPopState);
      }

      root._searchFiltersCleanup = function() {
        toggle.removeEventListener('click', openOverlay);
        Array.prototype.forEach.call(closeEls, function(b) { b.removeEventListener('click', closeOverlay); });
        document.removeEventListener('keydown', onEsc);
        if (filterForm) {
          filterForm.removeEventListener('change', onFilterChange);
          filterForm.removeEventListener('input', onFilterInput);
          filterForm.removeEventListener('submit', onFilterSubmit);
          filterForm.removeEventListener('click', onFilterClick);
        }
        window.removeEventListener('popstate', onFilterPopState);
        if (filterTimer) clearTimeout(filterTimer);
        if (filterAbort) { try { filterAbort.abort(); } catch (_) {} }
      };
    }

    document.querySelectorAll('[data-section-id]').forEach(init);

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector('[data-section-id]') || event.target;
      init(root);
    });
    document.addEventListener('shopify:section:unload', function(event) {
      var root = event.target.querySelector('[data-section-id]') || event.target;
      if (root && typeof root._searchFiltersCleanup === 'function') root._searchFiltersCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-categories"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCategories(root) {
      if (!root) return;
      var track = root.querySelector('[data-categories-track]');
      if (!track) return;
      var prev = root.querySelector('[data-categories-prev]');
      var next = root.querySelector('[data-categories-next]');
      var progress = root.querySelector('[data-categories-progress]');

      function cardStep() {
        var first = track.firstElementChild;
        if (!first) return track.clientWidth;
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function visibleCount() {
        var step = cardStep();
        return step > 0 ? Math.max(1, Math.round(track.clientWidth / step)) : 1;
      }

      function setsCount() {
        var total = track.children.length;
        return Math.max(1, Math.ceil(total / visibleCount()));
      }

      function update() {
        if (!progress) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          progress.style.width = '100%';
          progress.style.left = '0%';
          return;
        }
        // Bar width = visible portion of the track (more cards → smaller bar).
        // Bar position = scroll progress through the remaining travel.
        var widthPct = (track.clientWidth / track.scrollWidth) * 100;
        var travelPct = (100 - widthPct) * (track.scrollLeft / max);
        progress.style.width = widthPct + '%';
        progress.style.left = travelPct + '%';
      }

      function scrollToSet(index) {
        var sets = setsCount();
        if (sets <= 1) return;
        var max = track.scrollWidth - track.clientWidth;
        var wrapped = ((index % sets) + sets) % sets;
        track.scrollTo({ left: (wrapped / (sets - 1)) * max, behavior: 'smooth' });
      }

      function currentSetIndex() {
        var sets = setsCount();
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        return sets > 1 ? Math.round(ratio * (sets - 1)) : 0;
      }

      if (prev) prev.addEventListener('click', function() { scrollToSet(currentSetIndex() - 1); });
      if (next) next.addEventListener('click', function() { scrollToSet(currentSetIndex() + 1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      // Trackpad horizontal swipes emit both deltaX and deltaY. When the
      // user's intent is clearly horizontal (deltaX dominates), suppress the
      // browser's default behaviour so the page does not also scroll
      // vertically, and apply the horizontal delta to the track ourselves.
      track.addEventListener('wheel', function(e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          var max = track.scrollWidth - track.clientWidth;
          if (max > 0) {
            e.preventDefault();
            track.scrollLeft += e.deltaX;
          }
        }
      }, { passive: false });

      // Re-measure once layout has fully settled. At first paint the track
      // can briefly report scrollWidth === clientWidth (web fonts not yet
      // applied, lazy images not reserved space, Tailwind utilities still
      // resolving), which makes the progress bar render full-width until
      // the next scroll. Belt-and-suspenders: measure on the next frame,
      // on window load, and once fonts are ready.
      update();
      requestAnimationFrame(update);
      window.addEventListener('load', update);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(update);
      }
    }

    document.querySelectorAll('[data-section-id][id^="shop-by-categories-"]').forEach(initCategories);

    document.addEventListener('shopify:section:load', function(event) {
      var root = event.target.querySelector('[id^="shop-by-categories-"]') || event.target;
      initCategories(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
